import React from 'react';

import './Disclaimer.sass';

// TODO: Pull out email address below into a configuration
const Disclaimer: React.StatelessComponent<{}> = () => (
    <div className="Inventory-disclaimer">
        Due to our high turnover rate, this catalog is not guaranteed to be accurate. If you would like more information
        on one of our inventory listings, please call us at <a href="tel:615-256-2033">(615) 256-2033</a> or email us
        at <a href="mailto:gruhn@gruhn.com">gruhn@gruhn.com</a>. Thank you for browsing our catalog.
        <br />
    </div>
);

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/pages/inventory/Disclaimer.tsx